import { RANGE, CHECKBOX_SELECT } from '../constants';
const getFilterRangesAndCheckboxesValues = filters => {
  const checkboxSelectValues = [];
  const rangeValues = [];
  filters.forEach(({
    type,
    propsToDisplay
  }) => {
    if (CHECKBOX_SELECT.includes(type)) {
      checkboxSelectValues.push(propsToDisplay[0]);
    } else if (type === RANGE) {
      rangeValues.push(...propsToDisplay);
    }
  });
  return [checkboxSelectValues, rangeValues];
};
export default getFilterRangesAndCheckboxesValues;
//# sourceMappingURL=get-filter-ranges-and-checkboxes-values.js.map